/* Nissan NL: load with defer after global.min.js, before DOMContentLoaded.
 * StarApps retains its 26-media source and filters each model to 11 nodes.
 * Kalles calls thumbnailsMarkup before Flickity creates its cells; moving
 * those existing nodes first makes both the slides and native thumbs agree.
 */
(function (window, document) {
  'use strict';

  function isNissanMainProduct(element) {
    if (!element) return false;
    try {
      var product = JSON.parse(element.getAttribute('data-product-featured'));
      return product && String(product.id) === '10814848532814' && product.isMainProduct === true;
    } catch (error) {
      return false;
    }
  }

  var products = Array.from(document.querySelectorAll('[data-product-featured]'));
  if (!products.some(isNissanMainProduct)) return;

  var Carousel = window.T4SThemeSP && window.T4SThemeSP.Carousel;
  var prototype = Carousel && Carousel.prototype;
  var original = prototype && prototype.thumbnailsMarkup;
  if (typeof original !== 'function' || original.coNissanGalleryOrder) return;

  // Media IDs from gallery-cards-20260915/order-plan.json, not image IDs.
  var common = [
    '54718686724430', '49004975292750', '50641675551054', '50641675583822',
    '50627186950478', '49004975325518', '57313878344014', '49004975456590'
  ];
  var groups = [
    ['56159766118734', '56159784075598', '56159784042830'], // GTR
    ['56159767789902', '73711704539470', '73711704572238'], // 370z
    ['73696968704334', '73711829254478', '73711829287246'], // Qashqai
    ['73696970080590', '73711829320014', '73711829352782'], // X-Trail
    ['73700540318030', '73711829385550', '73711829418318'], // Micra
    ['73700540481870', '73711829451086', '73711829483854']  // Navara
  ];
  var orders = groups.map(function (group) {
    return [group[0]].concat(common.slice(0, 4), group.slice(1), common.slice(4));
  });

  function orderBeforeInitialization(carousel) {
    var element = carousel && carousel.el;
    if (!element || !element.hasAttribute('data-main-media')) return;
    if (!isNissanMainProduct(element.closest('[data-product-featured]'))) return;
    if (carousel.flkty || element.classList.contains('flickityt4s-enabled')) return;

    var slides = Array.from(element.querySelectorAll('[data-main-slide]'));
    if (slides.length !== 11) return;
    if (slides.some(function (slide) {
      return slide.parentElement !== element || slide.classList.contains('is--media-hide');
    })) return;

    var byId = new Map(slides.map(function (slide) {
      return [slide.getAttribute('data-media-id'), slide];
    }));
    if (byId.size !== 11) return;
    var order = orders.find(function (candidate) {
      return candidate.every(function (mediaId) { return byId.has(mediaId); });
    });
    if (!order) return;
    if (order.every(function (mediaId, index) { return byId.get(mediaId) === slides[index]; })) return;

    // Move original elements, retaining media state, attributes and listeners.
    order.forEach(function (mediaId) { element.appendChild(byId.get(mediaId)); });
  }

  function thumbnailsMarkup() {
    orderBeforeInitialization(this);
    return original.apply(this, arguments);
  }
  thumbnailsMarkup.coNissanGalleryOrder = '20260915';
  prototype.thumbnailsMarkup = thumbnailsMarkup;
}(window, document));
